import * as modalsActions from './actions'
import * as modalsTypes from './types'
import modals from './reducer'

export {modalsActions, modalsTypes}

export default modals
